import React, { useState } from 'react';
import { Container, Typography, Button, Box } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import FuncionarioForm from '../components/FuncionarioForm';
import FuncionarioList from '../components/FuncionarioList';
import { actionButtonSx, pageTitleSx } from '../styles/uiTokens';

function FuncionariosPage() {
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [refresh, setRefresh] = useState(0);

  const handleAdd = () => {
    setEditing(null);
    setShowForm(true);
  };

  const handleEdit = (f) => {
    setEditing(f);
    setShowForm(true);
  };

  const handleCancel = () => {
    setShowForm(false);
    setEditing(null);
  };

  const handleSaved = () => {
    setRefresh((r) => r + 1);
  };

  return (
    <Container maxWidth="md" sx={{ mt: 2, mb: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, gap: 2, flexWrap: 'wrap' }}>
        <Typography variant="h4" gutterBottom sx={pageTitleSx}>
          Funcionários
        </Typography>

        {!showForm && (
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleAdd}
            sx={actionButtonSx}
          >
            Novo Funcionário
          </Button>
        )}
      </Box>

      {showForm && (
        <FuncionarioForm
          initialData={editing}
          onFuncionarioAdded={handleSaved}
          onCancelEdit={handleCancel}
        />
      )}

      <FuncionarioList
        refresh={refresh}
        onEdit={handleEdit}
        onDeleted={handleSaved}
      />
    </Container>
  );
}

export default FuncionariosPage;
